import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "18", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "6", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 11.5V15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 3-6 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 9-6-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "9", y2: "21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "GitPullRequestClosed";
const GitPullRequestClosed = memo(themed(Icon));
export {
  GitPullRequestClosed
};
//# sourceMappingURL=git-pull-request-closed.js.map
